module.exports = __webpack_public_path__ + "img/mobile/Background/background_portrait@3x.jpg?1.0.17";